import moment from 'moment';

export const returnObjectData = (currentObject, key) =>{
    return currentObject[key]?currentObject[key].description: null;
}

export const returnCarrierName = (currentObject,key) => {
    return currentObject[key]? currentObject[key].name: null
}


export const returnFormattedDate = (date) => {
    console.log(date);
    console.log(returnFormattedDateTime(date));
    if(date === null){
        return null;
    }
    if(date.length === 8){
        return returnFormattedDateTime(date);
    }
    else{
        return null;
    }
}

const returnFormattedDateTime = (date) => {
    console.log(moment(date, 'YYYY,MM,DD').format('MM/DD/YYYY'));
    return moment(date, 'YYYY,MM,DD').format('MM/DD/YYYY');
}

export const getCoverageType = (currentObject,code) => {
    //form.vehicle.initial.coverages[1].coverageType
    const coverage = currentObject.coverages.find(element=>{
        return element.coverageType.code === code;
    });
    if(coverage){
        const coverageString = `${coverage.individualLimitAmount}:${coverage.occurrenceLimitAmount}`;

        //individualLimitAmount
        //occurrenceLimitAmount

        return coverageString;
    }
    return null;
}

export const returnRegisteredOwner = (owner) => {

    if (owner !== undefined) {
        const formattedName = `${owner.givenName} ${owner.surname}`;
        return formattedName;
    }
    else {
        return null;
    }
}

export const returnFormatedZip = (zip) => { 
    if(zip.length >= 5){
        return zip.substring(0,5);
    }
    else{
        return null
    }
    
}


// WEBPACK FOOTER //
// ./src/utils/formatReturnedData.js